import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { productFields } from './common/productFields';
import {
  buildingCommonFields,
  buildingRevisionFields,
} from './common/buildingCommonFields';
import { msg } from '@lingui/core/macro';
import {
  casNumberField,
  hazardClassField,
  substanceOfConcernField,
  euPrtrGroupField,
} from './common/substanceFields';
import { massUnitField } from './common/sharedFields';

export const substanceOutflowMetadata = {
  displayName: msg({
    message: 'Substance outflow',
    context: 'Activity data schema name for substance outflow',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...productFields,
    ...buildingCommonFields,
    ...buildingRevisionFields,
    cas_number: casNumberField,
    eu_prtr_group: euPrtrGroupField,
    hazard_class: hazardClassField,
    quantity: {
      displayName: msg({
        message: 'Substance outflow',
        context: 'The quantity of the substance released.',
      }),
      externalDescription: msg({
        message: 'The quantity of the substance released.',
        context: 'Substance quantity',
      }),
    },
    substance_of_concern: substanceOfConcernField,
    substance_outflow_medium: {
      displayName: msg({
        message: 'Substance outflow medium',
        context: 'The medium through which the substance is released.',
      }),
      externalDescription: msg({
        message: 'The medium through which the substance is released.',
        context: 'Substance outflow medium',
      }),
    },
    unit: massUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
